import { api } from '../api/client';
import type { ListParams } from './list-params';

/** Downloads a CSV export of the current list view, including filters and sort. */
export async function downloadCsv(path: string, params: Partial<ListParams>, extra: Record<string, unknown> = {}) {
  const { page: _p, pageSize: _ps, ...rest0 } = params;
  const rest = { ...rest0, ...extra };
  const res = await api.get(path, { params: rest, responseType: 'blob' });
  const disposition = (res.headers['content-disposition'] as string | undefined) ?? '';
  const match = /filename="?([^";]+)"?/.exec(disposition);
  const filename = match?.[1] ?? 'export.csv';
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
